export default "__VITE_ASSET__NjAPYURs__"